export default "__VITE_ASSET__BkNzSXz0__"